<div class="footer">
    Copyright © 2021 Wabtec Corporation. All rights reserved.
</div>